import React, {useState, useContext} from "react";
import { FaSpinner } from 'react-icons/fa';

function LoadingSpinner(props) {
    if (!props.active) {
        return <></>;
    }
  return (
    <div className="loading-overlay">
        <div className="spinner">
            <FaSpinner className="fill" />
        </div>
    </div>
  );
}

export default LoadingSpinner;
